import request from '@/utils/request'

export function getAdvertList(query) {
    return request({
        url: '/system/advert/pc/list',
        method: 'get',
        params: query
    })
}
